//  _        _      _         _
// | |  _  _| |_  _| |__ _  _| |__ _  _
// | |_| || | | || | '_ \ || | '_ \ || |
// |____\_,_|_|\_,_|_.__/\_,_|_.__/\_,_|
//
// Copyright © Lulububu Software GmbH - All Rights Reserved
// https://lulububu.de
//
// Unauthorized copying of this file, via any medium is strictly prohibited!
// Proprietary and confidential.

const german = {
    // F1
    appointmentType:   'Termintyp',
    constructor:       'Boot',
    constructorRating: 'Team-Wertung',
    countDownDay:      'Tag',
    countDownDays:     'Tage',
    countDownHour:     'Stunde',
    countDownHours:    'Stunden',
    countDownMinute:   'Minute',
    countDownMinutes:  'Minuten',
    countDownSecond:   'Sekunde',
    countDownSeconds:  'Sekunden',
    currentRace:       'Aktuelle Wettfahrt',
    driver:            'Crew-Mitglied',
    end:               'Ende',
    flashTable:        'Draft',
    meters:            'Meter',
    noRacingStable:    'Alle Teams',
    racingStable:      'Mannschaft',
    rank:              'Rang',
    rankShort:         '#',
    rounds:            'Runden',
    score:             'Score',
    scoring:           'Scoring',
    service:           'Service',
    sum:               'Gesamt',
    ticker:            'Ticker',
    t1Short:           'T1',
    t2Short:           'T2',
    t3Short:           'T3',
    t3TnShort:         'T3+Tn',
    ts7:               'TS7',
    vpShort:           'Spieler',

    // Default app
    and:                     'und',
    appHeadline:             'F1',
    appointments:            'Termine',
    f1Team:                  'F1-Team',
    f1Qualifying:            'F1-Qualifying',
    game:                    'Spiel',
    gameday:                 'Spieltag',
    gameLogo:                'Spiel-Logo',
    goals:                   'Tore',
    home:                    'Übersicht',
    meter:                   'Runden',
    player:                  'Spieler',
    more:                    'Mehr',
    oclock:                  'Uhr',
    quote:                   'Quote',
    or:                      'oder',
    pageTitle:               'TauRes SalesGame',
    parallelGames:           'Parallel-Spiele',
    points:                  'Punkte',
    pointsTotal:             'Gesamtpunkte',
    runs:                    'Läufe',
    squad:                   'Kader',
    statistic:               'Statistik',
    taures:                  'TauRes',
    team:                    'Mannschaft',
    team2:                   'Team',
    tendency:                'Tendenz',
    time:                    'Zeit',
    tickerDateFormat:        'HH:mm - DD.MM.YY',
    trend:                   'Trend',
    tvp:                     'T/VP',
    versionNumberDateFormat: 'DD.MM.YYYY HH:mm:ss',
};

module.exports = german;
